import * as Yup                 from    'yup';


export default Yup.object({
    number                     :Yup.string()
                                .required('Number is required!')
                                .min(10, 'Phone Number must be of 10 digit')
                                .max(10, 'Phone Number must be of 10 digit')
                                .test('numbers', 'Phone Number  must only contain numbers', (value: any) => {
                                    return /^[0-9]+$/.test(value);
                                }),
})